<template>
  <Select :model-value="selectedStatus" @update:model-value="handleStatusChange($event as string)">
    <SelectTrigger class="w-[180px]">
      <SelectValue placeholder="All Statuses" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="All">All Statuses</SelectItem>
      <SelectItem value="Active">Active</SelectItem>
      <SelectItem value="Inactive">Inactive</SelectItem>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Filter {
  key: string;
  value: string;
}

const props = defineProps<{
  filters: Filter[];
}>();

const emit = defineEmits<{
  'update-filter': [filters: { status: Filter }];
}>();

const selectedStatus = computed(() => {
  const statusFilter = props.filters.find(f => f.key === 'status');
  return statusFilter?.value || 'All';
});

function handleStatusChange(value: string) {
  emit('update-filter', { status: { key: 'status', value } });
}
</script>
